import { lazy } from "react";

const Signin = lazy(() => import("./Signin"));

const Error404 = lazy(() => import("./Error"));
const DownloadDocument = lazy(() => import("./DownloadDocument"));
const DownloadTicket = lazy(() => import("./DownloadTicket"));
const DownloadTicketFacture = lazy(() => import("./DownloadTicketFacture"));
const DownloadEtatCompte = lazy(() => import("./DownloadEtatCompte"));
const Sso = lazy(() => import("./Sso"));
const DownloadAbonnementCard = lazy(() => import("./DownloadAbonnementCard"));

const sessionsRoutes = [
  {
    path: "/session/signin",
    component: Signin
  },
  {
    path: "/session/sso",
    component: Sso
  },
  {
    path: "/session/document/download/:id/:token",
    exact: true,
    component: DownloadDocument
  },
  {
    path: "/session/ticket/download/:id/:token",
    component: DownloadTicket
  },
  {
    path: "/session/ticket_facture/download/:id/:token",
    component: DownloadTicketFacture
  },
  {
    path: "/session/etat_compte/download/:begin/:end/:id/:token/:other_company?",
    exact: true,
    component: DownloadEtatCompte
  },
  {
    path: "/session/abonnement_card/download/:id/:token",
    exact: true,
    component: DownloadAbonnementCard
  },
  {
    path: "/session/document/download/:company/:id/:token",
    exact: true,
    component: DownloadDocument
  },
  {
    path: "/session/etat_compte/download/:company/:begin/:end/:id/:token/:other_company?",
    exact: true,
    component: DownloadEtatCompte
  },
  {
    path: "/session/abonnement_card/download/:company/:id/:token",
    exact: true,
    component: DownloadAbonnementCard
  },
  {
    path: "/session/404",
    component: Error404
  }
];

export default sessionsRoutes;
